import { Link } from 'react-router-dom';
import { motion } from 'motion/react';
import { industries } from '@/mocks/homeData';

export default function IndustriesServed() {
  return (
    <section className="relative py-20 md:py-28 bg-background-100">
      <div className="w-full px-6 md:px-10 lg:px-16">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-14 md:mb-20"
        >
          <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-accent-600 mb-4">
            Sectors
          </span>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 mb-4">
            Industries We Serve
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-sm md:text-base leading-relaxed">
            From construction to healthcare, we deliver specialized trade and procurement solutions across East Africa&apos;s key economic sectors.
          </p>
        </motion.div>

        {/* Industries Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {industries.map((industry, index) => (
            <motion.div
              key={industry.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <Link
                to="/industries"
                className="group relative bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden hover:border-accent-200/50 transition-all duration-400 cursor-pointer block"
              >
                {/* Image area */}
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={industry.image}
                    alt={industry.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-primary-950/60 via-transparent to-transparent"></div>
                  <div className="absolute top-4 left-4 w-10 h-10 flex items-center justify-center rounded-xl bg-white/90 backdrop-blur-sm text-primary-600 group-hover:bg-accent-500 group-hover:text-white transition-all duration-400">
                    <i className={`${industry.icon} text-lg`}></i>
                  </div>
                </div>

                <div className="p-5">
                  <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-200">
                    {industry.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                    {industry.description}
                  </p>
                  <div className="mt-4 flex items-center gap-1 text-xs font-semibold text-accent-600 group-hover:text-accent-500 transition-colors duration-200 whitespace-nowrap">
                    Learn More <i className="ri-arrow-right-s-line"></i>
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>

        {/* Bottom CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.4, delay: 0.4 }}
          className="text-center mt-12"
        >
          <Link
            to="/industries"
            className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 border border-background-200 text-foreground-700 text-sm font-semibold rounded-full hover:bg-background-100 hover:border-accent-200 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            View All Industries
            <i className="ri-arrow-right-line"></i>
          </Link>
        </motion.div>
      </div>
    </section>
  );
}